/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Offerdetail_Reviews_Basedonreviews3Inputs */

const id_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Berdasarkan ${i?.count} ulasan`)
};

const ms_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Berdasarkan ${i?.count} ulasan`)
};

const da_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Baseret på ${i?.count} anmeldelser`)
};

const de_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Basiert auf ${i?.count} Bewertungen`)
};

const en_us2_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Based on ${i?.count} reviews`)
};

const es_es2_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Basado en ${i?.count} reseñas`)
};

const es_mx2_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Basado en ${i?.count} reseñas`)
};

const fil_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Batay sa ${i?.count} review`)
};

const fr_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Basé sur ${i?.count} avis`)
};

const it_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Basato su ${i?.count} recensioni`)
};

const hu_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} értékelés alapján`)
};

const nl_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gebaseerd op ${i?.count} reviews`)
};

const no_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Basert på ${i?.count} omtaler`)
};

const pl_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Na podstawie ${i?.count} recenzji`)
};

const pt_br2_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Baseado em avaliações de ${i?.count}`)
};

const pt_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Baseado em ${i?.count} avaliações`)
};

const ro_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bazat pe ${i?.count} recenzii`)
};

const fi_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perustuu ${i?.count} arvosteluun`)
};

const sv_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Baserat på ${i?.count} recensioner`)
};

const vi_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dựa trên ${i?.count} đánh giá`)
};

const tr_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} yoruma dayanarak`)
};

const cs_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Na základě ${i?.count} recenzí`)
};

const bg_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`На база ${i?.count} ревюта`)
};

const ru_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`На основе ${i?.count} обзоров`)
};

const uk_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`На основі ${i?.count} відгуків`)
};

const ar_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`بناءً على ${i?.count} مراجعة`)
};

const hi_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} समीक्षाओं पर आधारित`)
};

const th_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`จาก ${i?.count} รีวิว`)
};

const ja_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 件のレビューに基づく`)
};

const zh_cn2_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`基于 ${i?.count} 条评论`)
};

const zh_hant1_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`基於 ${i?.count} 條評論`)
};

const ko_offerdetail_reviews_basedonreviews3 = /** @type {(inputs: Offerdetail_Reviews_Basedonreviews3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`리뷰 ${i?.count}개 기준`)
};

/**
* | output |
* | --- |
* | "Based on {count} reviews" |
*
* @param {Offerdetail_Reviews_Basedonreviews3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_basedonreviews3 = /** @type {((inputs: Offerdetail_Reviews_Basedonreviews3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Basedonreviews3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "da") return da_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "de") return de_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "it") return it_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "no") return no_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "th") return th_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_basedonreviews3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_basedonreviews3(inputs)
	return ko_offerdetail_reviews_basedonreviews3(inputs)
});
export { offerdetail_reviews_basedonreviews3 as "offerDetail.reviews.basedOnReviews" }